"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parse_1 = require("../helpers/parse");
var Page = /** @class */ (function () {
    function Page(config, appState, index, book, resizer, language, testFeatures) {
        this.config = config;
        this.appState = appState;
        this.book = book;
        this.resizer = resizer;
        this.language = language;
        this.testFeatures = testFeatures;
        this.id = this.config.id;
        this.type = this.config.type || 'page';
        this.layers = this.config.layers;
        this.zoom = this.config.zoom || {};
        this.size = {
            height: this.resizer.previewPageHeight || this.config.height,
            width: this.resizer.previewPageWidth || this.config.width
        };
        this.index = index;
        this.zoomToggle = false;
    }
    Page.prototype.getOrientation = function () {
        var height = this.config.height || this.resizer.previewPageHeight;
        var width = this.config.width || this.resizer.previewPageWidth;
        var ratio = height / width;
        if (ratio > 1) {
            return 'portrait';
        }
        else if (ratio < 1) {
            return 'landscape';
        }
        return 'square';
    };
    Page.prototype.getLayer = function () {
        var tabId = this.appState.currentTab.group || this.appState.currentTab.id;
        var layers = this.layers;
        for (var _i = 0, layers_1 = layers; _i < layers_1.length; _i++) {
            var layer = layers_1[_i];
            for (var _a = 0, _b = layer.options; _a < _b.length; _a++) {
                var option = _b[_a];
                parse_1.evaluateOptions(option, Object.assign({
                    tabId: tabId,
                    hasFeature: this.testFeatures.hasFeature.bind(this.testFeatures)
                }, this.book));
            }
        }
        return layers;
    };
    Page.prototype.zoomPage = function (zoomIn, scale, x, y) {
        zoomIn = zoomIn !== false;
        this.zoomToggle = zoomIn;
        if (zoomIn) {
            scale = scale || this.zoom.scale;
            x = !isNaN(x) ? x : this.zoom.x;
            y = !isNaN(y) ? y : this.zoom.y;
            if (scale) {
                this.resizer.zoomPage(this.element, scale, x, y);
            }
        }
        else {
            this.resizer.zoomPage(this.element);
        }
    };
    Page.prototype.onMouseEnter = function () {
        if (this.appState.screen.touch) {
            return;
        }
        this.zoomPage(true);
    };
    Page.prototype.onMouseLeave = function () {
        if (this.appState.screen.touch) {
            return;
        }
        this.zoomPage(false);
    };
    Page.prototype.onTap = function () {
        if (!this.appState.screen.touch) {
            return;
        }
        this.zoomToggle = !this.zoomToggle;
        this.zoomPage(this.zoomToggle);
    };
    return Page;
}());
exports.Page = Page;
function PageDirective(config, book, resizer, $timeout) {
    'ngInject';
    return {
        restrict: 'AE',
        scope: true,
        bindToController: {
            page: '='
        },
        link: function () {
            $timeout(function () { resizer.resize(); });
        },
        controller: /** @class */ (function () {
            function PageController($scope, $element) {
                'ngInject';
                var _this = this;
                this.page.element = $element;
                $scope.$watch(function () { return book; }, function () { _this.page.getLayer(); }, true);
            }
            return PageController;
        }()),
        controllerAs: 'pageCtrl'
    };
}
exports.PageDirective = PageDirective;
function LayerDirective(config) {
    'ngInject';
    return {
        restrict: 'AE',
        templateUrl: config.params.base + 'templates/preview/layer.html'
    };
}
exports.LayerDirective = LayerDirective;
function LayerImageDirective($compile, preview) {
    'ngInject';
    return {
        restrict: 'AE',
        scope: {
            options: '=',
            dir: '='
        },
        link: function (scope, element) {
            scope.$watch(function () { return scope.options; }, function () {
                scope.option = scope.options.find(function (option) {
                    return option.condition;
                });
            }, true);
            element.append($compile('<img '
                + 'ng-if="option.condition && option.value" '
                + 'ng-src="{{dir}}/{{option.value}}"'
                + 'class="{{option.class}}"'
                + '>')(scope));
        }
    };
}
exports.LayerImageDirective = LayerImageDirective;
function LayerTextDirective($compile, book, appState, textResolver, testFeatures) {
    'ngInject';
    return {
        restrict: 'AE',
        scope: {
            options: '='
        },
        link: function (scope, elem) {
            Object.assign(scope, book);
            scope.math = Math;
            scope.resolve = textResolver.resolve.bind(textResolver);
            scope.hasFeature = testFeatures.hasFeature.bind(testFeatures);
            scope.isTab = function (id) {
                return appState.currentTab.group === id || appState.currentTab.id === id;
            };
            scope.option = scope.options.find(function (option) {
                return option.condition;
            });
            elem.append($compile('<span '
                + 'ng-if="option.condition && option.value" '
                + 'class="pb-preview-text {{option.class}}"'
                + '>' + scope.option.value + '</span>')(scope));
        }
    };
}
exports.LayerTextDirective = LayerTextDirective;
function LayerOverlayDirective($compile) {
    'ngInject';
    return {
        scope: {
            options: '=',
            previewCtrl: '=',
            dir: '='
        },
        restrict: 'AE',
        link: function (scope, elem) {
            scope.$watch(function () { return scope.options; }, function () {
                scope.option = scope.options.find(function (option) {
                    return option.condition;
                });
            }, true);
            elem.append($compile('<img '
                + 'ng-show="option.condition && option.value && previewCtrl.showOverlay(option)" '
                + 'ng-src="{{dir}}/{{option.value}}" '
                + 'class="{{option.class}}"'
                + '>')(scope));
        }
    };
}
exports.LayerOverlayDirective = LayerOverlayDirective;
function LayerUploadDirective($compile, uploads) {
    'ngInject';
    return {
        scope: {
            options: '='
        },
        link: function (scope, elem) {
            scope.uploads = uploads;
            scope.option = scope.options[0];
            elem.append($compile('<img '
                + 'ng-if="option.condition && uploads.getThumbnail(\'' + scope.option.value + '\')" '
                + 'ng-src="{{uploads.getThumbnail(\'' + scope.option.value + '\')}}"'
                + 'class="{{option.class}}"'
                + '>')(scope));
        }
    };
}
exports.LayerUploadDirective = LayerUploadDirective;
exports.default = Page;
